import { z } from 'zod';

export const filterSchema = z.object({
  search: z.string().default(''),
});
